export default "__VITE_ASSET__DNozv_cz__"